import React from "react";
interface FacebookIconSvgProps {
  smallWidth: boolean;
}
const FacebookIconSvg: React.FC<FacebookIconSvgProps> = ({
  smallWidth = false,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={smallWidth ? "25" : "43"}
      height={smallWidth ? "25" : "43"}
      fill="none"
      viewBox="0 0 43 43"
    >
      <path
        fill="#16303A"
        d="M21.166 42.334c11.69 0 21.167-9.477 21.167-21.167 0-11.69-9.477-21.166-21.166-21.166C9.476.001 0 9.478 0 21.167c0 11.69 9.477 21.167 21.166 21.167z"
      ></path>
      <path
        fill="#fff"
        d="M24.362 14.126h1.967v-3.272a27.782 27.782 0 00-2.866-.144 4.448 4.448 0 00-4.793 4.834v2.696h-3.214v3.661h3.218v9.381h3.85v-9.38h3.203l.48-3.663h-3.686v-2.334c0-1.08.293-1.78 1.84-1.78z"
      ></path>
    </svg>
  );
};

export default FacebookIconSvg;
